import React from 'react'

import Popover from 'components/common/Popover'
import PopoverMenu from 'components/common/PopoverMenu'
import Icon from 'components/Icon'
import NavIcon from 'components/navigation/Nav/NavIcon'
import { OnPageChange } from 'components/navigation/Notifications/OnPageChange'
import theme from 'theme'
import { track } from 'track'

export const NotificationsDropdown: React.FC<{
  activeAttacksCount?: number
  hasSchedules?: boolean
  pendingResultsScenariosCount?: number
  children: (props?: Record<string, any>) => React.ReactNode
}> = ({
  activeAttacksCount,
  hasSchedules,
  pendingResultsScenariosCount,
  children
}) => {
  // active attacks take priority
  const measleCount = activeAttacksCount || pendingResultsScenariosCount || 0
  const measleColor = activeAttacksCount
    ? theme.colors.blue[0]
    : theme.colors.orange[0]

  return (
    <Popover
      edgeBuffer={theme.space[4]}
      forceMeasureProps={[
        activeAttacksCount,
        pendingResultsScenariosCount,
        hasSchedules
      ]}
      openOnClick={true}
      onOpen={() => track('ActiveAttackNotificationOpened')}
    >
      {({ getTargetProps, getPopoverProps, open, closePopover }) => {
        return (
          <>
            <OnPageChange onChange={closePopover} />
            <NavIcon
              data-test-active-attacks-notification-popover
              data-track-action="active-attack-notification-icon-clicked"
              data-track-category="ActiveAttack"
              data-track-on="click"
              open={open}
              {...getTargetProps()}
            >
              <Icon
                css={{
                  display: 'flex',
                  color: 'inherit',
                  margin: 0,
                  fontSize: theme.fontSizes[3]
                }}
                icon="bolt"
              />
              {measleCount > 0 && (
                <div
                  css={{
                    position: 'absolute',
                    display: 'grid',
                    placeContent: 'center',
                    top: 0,
                    right: 0,
                    transform: 'translate(25%, -25%)',
                    fontSize: 10,
                    width: theme.space[3],
                    height: theme.space[3],
                    background: measleColor,
                    border: '1px solid',
                    borderColor: theme.colors.white[0],
                    color: theme.colors.white[0],
                    fontWeight: theme.fontWeights[1],
                    borderRadius: theme.borderRadius[2]
                  }}
                  data-test-active-attacks-notification-tag={
                    measleCount > 99 ? '99+' : measleCount
                  }
                >
                  {measleCount > 99 ? '99+' : measleCount}
                </div>
              )}
            </NavIcon>
            <PopoverMenu
              css={{
                display: 'block', // Need this because grid doesn't give an accurate width if part of the content is off the page.
                padding: theme.space[0]
              }}
              getPopoverProps={getPopoverProps}
            >
              {children({ closePopover, isOpen: open })}
            </PopoverMenu>
          </>
        )
      }}
    </Popover>
  )
}
